import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import UserDataSlice from "./UserData/UserDataSlice";

const combinedReducers = combineReducers({
  userDataSlice: UserDataSlice,  
})

const storage = configureStore({
  reducer: combinedReducers
})

export default storage;
